//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Angle",1,0],[0,"EdgeLength",1,0],[0,"NumberOfFormEdges",0,0]],[[["nose_radius","nose_angle","edge_length"],"Create",{R_:{form_edges:''}},3,0],[["node_index","nose_radius","nose_angle","edge_length"],"Modify",{},4,0],[["node_index"],"Delete",{},1,0],[["position","nose_radius","nose_angle","edge_length"],"Get",{},1,0]],[]];
SPLM.CAM.FormEdgesBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FormEdgesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;